(() => {
	angular.module('main').factory('referralsDataService', referralsDataService);

	referralsDataService.$inject = ['$http', '$q'];

	function referralsDataService($http, $q) {
		return {
			getAllReferrals
		};

		function getAllReferrals({
			perPage,
			page,
			pageOrder: { predicate, reverse },
			search
		}) {
			const deferred = $q.defer();

			$http({
				method: 'GET',
				url: '/admin/rest/referrals',
				params: {
					perPage,
					page,
					predicate,
					reverse,
					search
				}
			})
				.then(
					response => {
						deferred.resolve(response.data);
					},
					response => {
						deferred.reject(response);
					}
				)
				.catch(response => {
					deferred.reject(response);
				});
			return deferred.promise;
		}
	}
})();



// WEBPACK FOOTER //
// ./web/js/services/dataServices/referralsDataService.js